const Constants = {

    MODE_VIEW: "view",
    MODE_EDIT: "edit",
    MODE_DELETED: "deleted",

    FLOW_INIT: 0,
    FLOW_UPLOAD: 1,
    FLOW_UPLOAD_COMPLETE: 2,
    FLOW_EMOJI_PICKER: 3,
    FLOW_VIEW: 4,
    FLOW_DELETED: 5,
    FLOW_CONFIRM_DELETE: 6,
    FLOW_CONFIRM_REMOVE_LIKE: 7,
    FLOW_CONFIRM_REMOVE_DISLIKE: 8,
    FLOW_CONFIRM_REMOVE_UPVOTE: 9,
    FLOW_CONFIRM_REMOVE_DOWNVOTE: 10,
    FLOW_SHOW_EDIT: 11,
    FLOW_SHOW_ATTACHMENT: 12,

    UPLOAD_TYPE_IMAGE: "image",
    UPLOAD_TYPE_PDF: "pdf",
    UPLOAD_TYPE_VIDEO: "video",

    CONTENT_DELETED: "This content was deleted",

}

export {Constants};